import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 積算情報表示
 * ※CADAPIから取得した情報の表示
 */
class SekisanDialog extends Dialog {
  /**
       * コンストラクタ
       */
  constructor(draggable: boolean) {
    super(draggable);
    // ダイアログのコンテンツ生成
    const id = 'sekisanDialog';
    let title = '';
    // タイトル
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp': title = '積算情報'; break;
      default: title = 'Architecture Integration'; break;
    }
    let contents = '';
    contents += '<div class="p-webcadControlDescriptionBox sekisanDialog_contentBox">';
    // 外部
    contents += '<div class="subttl"><span class="jp">積算情報－基本情報</span><span class="en">External</span></div>';
    contents += '<table>';
    contents += '<tbody>';
    contents += '<tr><th>コード</th><th>項目名</th><th>数量</th></tr>';
    for (let i: number = 0; i < marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.gaibu.length; i += 1) {
      contents += '<tr>';
      contents += `<td class="codeCell">${marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.gaibu[i].code}</td>`;
      contents += `<td class="nameCell">${marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.gaibu[i].name}</td>`;
      contents += `<td class="itemValue">${marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.gaibu[i].value}`;
      contents += `<span class="itemUnit">${marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.gaibu[i].unit}</span></th>`;
      contents += '</tr>';
    }
    contents += '</tbody>';
    contents += '</table>';
    contents += '</div>';

    // 内部
    contents += '<div class="p-webcadControlDescriptionBox sekisanDialog_contentBox">';
    contents += '<div class="subttl"><span class="jp">積算情報－部屋別情報</span><span class="en">Internal</span></div>';
    contents += '<table>';
    contents += '<tbody>';
    contents += '<tr><th>コード</th><th>項目名</th><th>値</th></tr>';
    for (let i: number = 0; i < marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.naibu.length; i += 1) {
      for (let k: number = 0; k < marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.naibu[i].length; k += 1) {
        for (let n: number = 0; n < marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.naibu[i][k].estimate.length; n += 1) {
          contents += '<tr>';
          contents += `<td class="codeCell">${marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.naibu[i][k].estimate[n].code}</td>`;
          contents += `<td class="nameCell">${marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.naibu[i][k].estimate[n].name}</td>`;
          contents += `<td class="itemValue">${marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.naibu[i][k].estimate[n].value}`;
          contents += `<span class="itemUnit">${marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.naibu[i][k].estimate[n].unit}</span></th>`;
          contents += '</tr>';
        }
        contents += '<tr><td class="dividerLine" colspan="3"></td></tr>';
      }
    }
    contents += '</tbody>';
    contents += '</table>';
    contents += '</div>';

    let footer = '<button id="btnSekisanDown"><span class="jp">ダウンロード</span><span class="en">Download</span></button>';
    footer += '<button id="btnClose"><span class="jp">閉じる</span><span class="en">Close</span></button>';

    this.createDialog(id, title, contents, footer);

    document.getElementById('btnClose').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.removeDialog();
    });

    document.getElementById('btnSekisanDown').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.exportSekisanData();
    });
  }
}

export default SekisanDialog;
